<template>
 <div>
               <!-- 模态框本身 -->
               <div v-if="showModal" class="modal-content-share">
                 <!-- 关闭模态框的按钮 -->
                 <div></div>
                   <!-- 在模态框内部放置一个链接 -->
                <!-- <a :href="`https://www.facebook.com/sharer.php?t=${(currenttitle)}&u=${(currentUrl)}`"  class="share-buttonfacebook" target="_blank">Facebook</a>
                 <a :href="`https://twitter.com/intent/tweet?text=${(currenttitle)}&url=${(currentUrl)}`"  class="share-buttontwitter" target="_blank">Twitter</a>
                 <a  :href="`https://www.snapchat.com/scan?attachmentUrl=${(currentUrl)}`" class="share-buttonsnapchat" target="_blank">Snapchat</a>
                -->
                        <a :href="`https://www.facebook.com/sharer.php?t=Fun game sharing&amp;u=${(currentUrl)}`" class="sharelink" style="background: #4267b2;"><img :src="facebook" alt="share_facebook"> Facebook </a>
                        <a :href="`https://twitter.com/intent/tweet?text=Fun game sharing&amp;url=${(currentUrl)}`" aria-label="To twitter"  class="sharelink"  style="background: #55acee;"><img :src="twitter" alt="share_twitter"> Twitter </a>
                        <a :href="`https://www.snapchat.com/scan?attachmentUrl=${(currentUrl)}`" aria-label="To snapchat"  class="sharelink"  style="background: #fffc00;color:#000;"><img :src="snapchat" alt="share_snapchat"> Snapchat </a>
                        <a :href="`https://www.linkedin.com/shareArticle?mini=true&amp;title=Fun game sharing&amp;utl=${(currentUrl)}`" aria-label="To linkedin"  class="sharelink"  style="background: #ff8000;"><img :src="linkedin" alt="share_linkedin"> Linkedin </a>
                        <a :href="`mailto:?subject=Fun game sharing&amp;body=${(currentUrl)}`" aria-label="To email"  class="sharelink"  style="background: #7d7d7d;"><img :src="email" alt="share_email"> Email </a>
                        <a :href="`https://web.skype.com/share?utl=${(currentUrl)}&amp;text=Fun game sharing`" aria-label="To skype"  class="sharelink"  style="background: #00aff0;"><img :src="skype" alt="share_skype"> Skype </a>
                        <a :href="`https://reddit.com/submit?utl=${(currentUrl)}&amp;title=Fun game sharing`" aria-label="To reddit"  class="sharelink"  style="background: #ff4500;"><img :src="reddit" alt="share_reddit"> Reddit </a>
                        <a :href="`https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://ads.snsmi.com/&amp;title=Fun game sharing`" aria-label="To tumblr"  class="sharelink"  style="background: #32506d;"><img :src="tumblr" alt="share_tumblr"> Tumblr</a>
                        <div class="closeShare" style=""><img :src="close" alt="close"  @click="showModal = false;"></div>
                        <div class="more_share_bg" style=""></div>
                 </div>
           </div>
  <div class="navbar">
  <hamburger
        id="hamburger-container"
        :is-active="sidebar.opened"
        class="hamburger-container"
        @toggleClick="toggleSideBar"
      />

<svg @click="showModal = true;" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 70 70" width="50px" height="50px" class="share"><path d="M 40 0 C 34.535156 0 30.078125 4.398438 30 9.84375 C 30 9.894531 30 9.949219 30 10 C 30 13.6875 31.996094 16.890625 34.96875 18.625 C 36.445313 19.488281 38.167969 20 40 20 C 45.515625 20 50 15.515625 50 10 C 50 4.484375 45.515625 0 40 0 Z M 28.0625 10.84375 L 17.84375 15.96875 C 20.222656 18.03125 21.785156 21 21.96875 24.34375 L 32.3125 19.15625 C 29.898438 17.128906 28.300781 14.175781 28.0625 10.84375 Z M 10 15 C 4.484375 15 0 19.484375 0 25 C 0 30.515625 4.484375 35 10 35 C 12.050781 35 13.941406 34.375 15.53125 33.3125 C 18.214844 31.519531 20 28.472656 20 25 C 20 21.410156 18.089844 18.265625 15.25 16.5 C 13.71875 15.546875 11.929688 15 10 15 Z M 21.96875 25.65625 C 21.785156 28.996094 20.25 31.996094 17.875 34.0625 L 28.0625 39.15625 C 28.300781 35.824219 29.871094 32.875 32.28125 30.84375 Z M 40 30 C 37.9375 30 36.03125 30.644531 34.4375 31.71875 C 31.769531 33.515625 30 36.542969 30 40 C 30 40.015625 30 40.015625 30 40.03125 C 29.957031 40.035156 29.917969 40.058594 29.875 40.0625 L 30 40.125 C 30.066406 45.582031 34.527344 50 40 50 C 45.515625 50 50 45.515625 50 40 C 50 34.484375 45.515625 30 40 30 Z"/></svg>
    <weather v-if="weatherOpen && !isMobile" class="navbar-weather" />
    <div class="right-menu">
     <a href="/"><img :src="logo" class="sidebar-logo" /></a>
  </div>

  </div>

</template>

<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'
import logo from '@/assets/logo/logo.png'
import facebook from '@/assets/logo/facebook.png'
import linkedin from '@/assets/logo/linkedin.png'
import reddit from '@/assets/logo/reddit.png'
import email from '@/assets/logo/email.png'
import skype from '@/assets/logo/skype.png'
import snapchat from '@/assets/logo/snapchat.png'
import twitter from '@/assets/logo/twitter.png'
import tumblr from '@/assets/logo/tumblr.png'
import close from '@/assets/logo/close.png'
import Hamburger from '@/components/Hamburger'
import Weather from '@/components/Weather'
const store = useStore()
const sidebar = computed(() => store.getters['app/sidebar'])
const weatherOpen = computed(() => store.getters['settings/weatherOpen'])

function toggleSideBar() {
  store.dispatch('app/toggleSideBar')
}
</script>
<script>
export default {
  data() {
    return {
      currentUrl: window.location.href,
      currenttitle: document.title,
      showModal: false
    }
  }
}
</script>
<style>
  .modal-content-share {
         padding-top: 90px;
         position: fixed;
         display: flex;
         flex-wrap: wrap;
         justify-content: center;
         z-index: 9999;
         .sharelink {
                 z-index: 9999;
                 display: flex;
                 align-items: center;
                 justify-content: center;
                 color: #fff;
                 width: 180px;
                 height: 50px;
                 box-sizing: border-box;
                 padding: .1rem;
                 border-radius: 5px;
                 margin: .1rem;
                 img {
                         margin-right: 5px;
                         width: 30px;
                         height: 30px;
                     }
                 }
         .more_share_bg {
             position: fixed;
             top: 0;
             left: 0;
             bottom: 0;
             right: 0;
             width: 100%;
             height: 100%;
             background: #000;
             opacity: .7;
             z-index: 9998;
         }
         .closeShare {
                 position: fixed;
                 top: 1rem;
                 right: 0.5rem;
                 z-index: 9999;
                 cursor: pointer;
                img {
                       width: 40px;
                       height: 40px;
                   }
             }

}
</style>
<style lang="scss" scoped>
.navbar {
  height: 70px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  background: rgba(255,255,255,0.5);
  .sidebar-logo{
   width: 70px;
   height:70px;
   margin-right:15px;
  }
  .share {
   margin: 18px 0px 0px 0px;
  }
.share-buttons {
    margin: 10px 0;
}
  .hamburger-container {
    line-height: 70px;
    height: 20%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .navbar-weather {
    float: left;
    margin: 15px;
  }

  .right-menu {
    float: right;
    height: 80%;
    display: flex;

    .source-code {
      margin-right: 10px;
      display: inline-block;
      font-size: 30px;
      height: 100%;
      vertical-align: text-bottom;
    }
  }
}
</style>
